import PropTypes from 'prop-types';
import { useNavigate, useParams } from 'react-router-dom';
import { useEffect, useState } from 'react';
import { useAuth } from 'contexts/AuthContext';
import api from 'services/api';
import { SecurityScanOutlined } from '@ant-design/icons';

/**
 * Wrapper around a component that requires auth to be displayed.
 *
 * Redirects to nonAuth page if someone tries to render the children without being authorized.
 */
function checkAdmin(user) {
  if (user.roles.includes('ROLE_FED_ADMIN')) {
    return true;
  }
  return false;
}

function RequireAdmin({ children }) {
  const [loading, setloading] = useState(true);
  const [u, setU] = useState([]);
  const nav = useNavigate();
  const { user } = useAuth();
  const { sId, federationId } = useParams();
  useEffect(() => {
    async function fetch() {
      const result = await api.get(`/users/${user.id}`);
      if (result.data.roles.includes('ROLE_SUPER_ADMIN') === false && result.data.roles.includes('ROLE_FED_ADMIN') === false && result.data.roles.includes('ROLE_MULTISCUTCHING_ADMIN') === false) {
        return nav('/unauthorized');
      }
      setU(result.data);
      setloading(false);
      return true;
    }
    fetch();
  }, [user]);

  if (loading === true) {
    return (
      <SecurityScanOutlined
        style={{
          position: 'absolute', right: '50%', top: '50%', fontSize: '5em',
        }}
        className="security-spinner"
      />
    );
  }
  if (u.roles.includes('ROLE_SUPER_ADMIN') || (u.roles.includes('ROLE_MULTISCUTCHING_ADMIN'))) {
    return children;
  }
  if (u.managedFederation.id === federationId && !u.roles.includes('ROLE_SUPER_ADMIN')) {
    return children;
  }
  return children;
}

RequireAdmin.propTypes = {
  children: PropTypes.node.isRequired,
};

export { RequireAdmin, checkAdmin };
